import { type RecentConversation } from '../../../value-objects/RecentConversation'
import { type IRecentConversationsRepository } from '../../interfaces/IRecentConversationsRepository'

interface Dependency {
  recentConversationsRepository: IRecentConversationsRepository
}

export class GetRecentConversationsUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (): RecentConversation[] =>
    this.deps.recentConversationsRepository.getAll()
}
